export default "__VITE_ASSET__DEOXmFF8__"